import { ViewProps } from 'react-native';

import { CustomIcon } from './CustomIcon';
import { RecordButtonIconContainer } from './RecordButtonIconContainer';
import { useButtonColors } from '../hooks/useButtonColors';

interface Props extends ViewProps {
  isShown: boolean;
  isRecording: boolean;
  iconSize: number | undefined;
}

export const RecordButtonIcon = ({ isShown, style, isRecording, iconSize }: Props) => {
  const { iconOrTextColor } = useButtonColors();

  if (!isShown) {
    return null;
  }

  return (
    <RecordButtonIconContainer style={style}>
      <CustomIcon
        name={isRecording ? 'stop' : 'record'}
        color={iconOrTextColor}
        size={iconSize || 40}
      />
    </RecordButtonIconContainer>
  );
};
